import React, { useState } from 'react';
import './App.scss';
import AppRouter from "./routes/router";
// Import axios configuration early to ensure it's loaded
import './common/api/axiosConfig';
// import ReactNotificationComponent from "./ReactNotificationComponent";
// import { onMessageListener } from "./firebaseInit";
// import Notifications from "./Notifications";

function App({ additionalClass_main }) {
  // const [show, setShow] = useState(false);
  // const [notification, setNotification] = useState({ title: "", body: "" });
  // console.log(onMessageListener()
  // )
  // onMessageListener()
  //   .then((payload) => {
  //     setShow(true);
  //     setNotification({
  //       title: payload.notification.title,
  //       body: payload.notification.body,
  //     });
  //     console.log(payload);
  //   })
  //   .catch((err) => console.log("failed: ", err));
  return (
    <div className="ebw">
      <AppRouter />
      {/* {show && notification.body != "" ? (
        <ReactNotificationComponent
          title={notification.title}
          body={notification.body}
        />
      ) : (
        <></>
      )} */}
      {/* <Notifications /> */}
    </div>
  );
}
export default App;
